module.exports = __webpack_public_path__ + "images/landingPageCake_5.png";